'use client';
import { ConfigProvider } from 'antd';
import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/th'; // โหลด locale ภาษาไทย
import 'dayjs/locale/en'; // โหลด locale ภาษาอังกฤษ
import { useLocale } from 'next-intl';
import AuthLoginForm from '@/components/AuthComponents/AuthLoginForm';
import { useTheme } from '@/components/ThemeComponents/ThemeProvider';

export default function Home() {
  const localeLg = useLocale();
  dayjs.locale(localeLg);
  const themeData = useTheme();
  const color1 = themeData?.theme?.calVariable?.primaryColor;
  const color2 = themeData?.theme?.calVariable?.secondaryColor;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: color1,
          fontFamily: '"Prompt", sans-serif',
        },
        components: {
          Button: {
            colorPrimary: color1,
          },
        },
      }}
    >
      <div>
        <AuthLoginForm />
      </div>
    </ConfigProvider>
  );
}
